import React from "react";
import { useClock } from "../hooks/useClock";

// Tijd en datum rechtsboven.
const TopbarClock = () => {
  const { hours, minutes, date } = useClock();

  return (
    <div className="topbar-clock">
      <span className="tc-time">
        {hours}:{minutes}
      </span>
      <span className="tc-date">{date}</span>
    </div>
  );
};

export default TopbarClock;
